export default "__VITE_ASSET__BQhLuD1x__"